var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative pr-3 py-3 opp-container",
      class: "prelative oppstep-" + _vm.data.status + "-bordercolor-l"
    },
    [
      _c("div", { staticClass: "oppTitle pr-4" }, [
        _c(
          "a",
          {
            staticClass: "black-link bold",
            attrs: { href: _vm.overviewUrl, target: "_blank" }
          },
          [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]
        )
      ]),
      _vm._v(" "),
      _c("CompassIconButton", {
        staticClass: "pipeline-card__panel",
        attrs: { icon: "rightpanel" },
        on: {
          click: function($event) {
            return _vm.openPanel()
          }
        }
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "oppDetails" }, [
        _c("li", { staticClass: "mt-1" }, [
          _c("span", { staticClass: "semibold" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.data.formatted_potential) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.data.formatted_thirdname.params
          ? _c(
              "li",
              { staticClass: "mt-2 bold" },
              [
                _c("person-list", {
                  attrs: {
                    list: _vm.data.formatted_thirdname.params.list,
                    context: "opportunity",
                    "related-data": { type: "opportunity", id: _vm.data.id }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.formatted_thirdcontacts.params
          ? _c(
              "li",
              { staticClass: "mt-1 l" },
              [
                _c("person-list", {
                  attrs: {
                    list: _vm.data.formatted_thirdcontacts.params.list,
                    context: "opportunity",
                    "related-data": { type: "opportunity", id: _vm.data.id }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.formatted_tasks
          ? _c(
              "li",
              { staticClass: "mt-2" },
              [
                _c(
                  "listing-dropdown",
                  _vm._b(
                    { attrs: { step: _vm.data.step, placeholder: "" } },
                    "listing-dropdown",
                    _vm.data.formatted_tasks.params,
                    false
                  )
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.formatted_events
          ? _c(
              "li",
              { staticClass: "mt-2" },
              [
                _c(
                  "listing-dropdown",
                  _vm._b(
                    { attrs: { placeholder: "" } },
                    "listing-dropdown",
                    _vm.data.formatted_events.params,
                    false
                  )
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.formatted_nbLinkedDocs
          ? _c(
              "li",
              { staticClass: "mt-2" },
              [
                _c(
                  "listing-dropdown",
                  _vm._b(
                    { attrs: { placeholder: "" } },
                    "listing-dropdown",
                    _vm.data.formatted_nbLinkedDocs.params,
                    false
                  )
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showMore
        ? _c("ul", { staticClass: "oppMoreDetails mt-2" }, [
            _vm.data.thirdscore
              ? _c(
                  "a",
                  { attrs: { href: "javascript:;" }, on: { click: _vm.score } },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "score label label-nobackground label-border"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.data.formatted_thirdscore) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "mt-2" }, [
              _c("span", { staticClass: "gray-60" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Échéance")) +
                    "\n            "
                )
              ]),
              _vm._v("\n            :\n            "),
              _c("span", { staticClass: "semibold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.data.formatted_dueDate) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mt-1" }, [
              _c("span", { staticClass: "gray-60" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Création")) +
                    "\n            "
                )
              ]),
              _vm._v("\n            :\n            "),
              _c("span", { staticClass: "semibold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.data.formatted_created) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mt-2" }, [
              _c("span", { staticClass: "gray-60" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("ID")) +
                    "\n            "
                )
              ]),
              _vm._v("\n            :\n            "),
              _c("span", {
                staticClass: "semibold",
                domProps: { innerHTML: _vm._s(_vm.data.ident) }
              })
            ]),
            _vm._v(" "),
            _vm.data.nbDayInCurrentStep > 0
              ? _c("li", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "gray-60" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Dans l'étape depuis")) +
                        "\n            "
                    )
                  ]),
                  _vm._v("\n            :\n            "),
                  _c("span", { staticClass: "semibold" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.data.formatted_nbDayInCurrentStep) +
                        "\n            "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.formatted_staffs && _vm.data.formatted_staffs.params
              ? _c(
                  "li",
                  { staticClass: "mt-2 prelative" },
                  [
                    _c("span", { staticClass: "gray-60" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$l10n.__("Collaborateurs affectés")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("person-list", {
                      staticClass: "semibold",
                      attrs: { list: _vm.data.formatted_staffs.params.list }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.data.formatted_owner && _vm.data.formatted_owner.params
              ? _c(
                  "li",
                  { staticClass: "mt-2 prelative opp-owner" },
                  [
                    _c("span", { staticClass: "gray-60" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$l10n.__("Propriétaire")) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("person-list", {
                      staticClass: "semibold",
                      attrs: { list: _vm.data.formatted_owner.params.list }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CompassIconButton", {
        staticClass: "pipeline-card__show-more",
        attrs: {
          icon: _vm.showMore ? "caret-up" : "caret-down",
          size: "small"
        },
        on: { click: _vm.toggleShowMore }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }